import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LIVE_SITE } from '../../utils';

export default class GoogleAdSense extends Component {
  componentDidMount() {
    if (window) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }

  render() {
    const {
      className,
      slot,
      format,
      style,
      layout,
      layoutKey,
      responsive,
    } = this.props;

    return (
      <ins
        className={ className ? `${className} adsbygoogle` : `adsbygoogle` }
        style={style}
        data-ad-test={ LIVE_SITE ? `off` : `on` }
        data-ad-client="ca-pub-9379146346152432"
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-ad-layout-key={layoutKey}
        data-full-width-responsive={responsive}
      />
    );
  }
}

GoogleAdSense.propTypes = {
  className: PropTypes.string,
  slot: PropTypes.string,
  format: PropTypes.string,
  style: PropTypes.object,
  layout: PropTypes.string,
  layoutKey: PropTypes.string,
  responsive: PropTypes.string,
};
